(function ($, Drupal) {
  Drupal.behaviors.profiletabs = {
    attach: function (context, settings) {

      var tabLink = context.querySelector('.block-inline-blockprofile-company-history-block .tablinks');

      if (tabLink) {
        $('.block-inline-blockprofile-company-history-block .tablinks').on('click', function (evt) {
          var i, tabcontent, tablinks;

          tabcontent = context.getElementsByClassName("tabcontent");
          for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
          }

          tablinks = context.getElementsByClassName("tablinks");
          for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
          }

          var cityName = this.value;
          context.getElementById(cityName).style.display = "block";
          evt.currentTarget.className += " active";
        });
      }

      var defaultTabLink = document.getElementById("defaultOpen");
      if (defaultTabLink) {
        defaultTabLink.click();
      }

    }
  };
})(jQuery, Drupal);
